import { render, staticRenderFns } from "./DropTarget.vue?vue&type=template&id=3da0248e&scoped=true&"
import script from "./DropTarget.vue?vue&type=script&lang=js&"
export * from "./DropTarget.vue?vue&type=script&lang=js&"
import style0 from "./DropTarget.vue?vue&type=style&index=0&id=3da0248e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da0248e",
  null
  
)

export default component.exports